module.exports = __webpack_public_path__ + "img/settings-icon.f97cafdd.svg";